import { getDns, getIsIptveditor } from './axios';
import { getInfo } from './user_info';

// Função auxiliar: usar proxy.php para URLs HTTP quando página está em HTTPS
function getProxiedUrl(url) {
  if (!url || typeof url !== 'string') return url;
  if (window.location.protocol === 'https:' && url.startsWith('http://')) {
    return `${window.location.origin}/proxy.php?url=${encodeURIComponent(url)}`;
  }
  return url;
}

export function generateUrl(type, id, extension) {
  const iptveditorApi =
    typeof window !== 'undefined' && window.REACT_APP_IPTVEDITOR_API
      ? window.REACT_APP_IPTVEDITOR_API
      : process.env.REACT_APP_IPTVEDITOR_API || '';
  const dns = getIsIptveditor() === true ? iptveditorApi : getDns();
  const user = getInfo().username;
  const pass = getInfo().password;
  const url = `${dns}${type}/${user}/${pass}/${id}.${
    getIsIptveditor() === true ? 'mp4' : extension
  }`;
  return getProxiedUrl(url);
}

export function convertTsToM3u8(ip) {
  if (!ip || typeof ip !== 'string') return ip;

  const trimmed = ip.trim();

  // Se URL tem query params/token ou caminhos especiais (ex: //hlsr/), manter original
  if (
    trimmed.includes('?') ||
    trimmed.includes('token=') ||
    trimmed.includes('/hlsr/')
  ) {
    return getProxiedUrl(trimmed);
  }

  const segments = trimmed.split('/');
  const liveIndex = segments.findIndex((segment) => segment === 'live');

  // Apenas reescrever URLs no formato esperado: /live/{user}/{pass}/{id}.{ext}
  if (liveIndex === -1 || segments.length < liveIndex + 4) {
    return getProxiedUrl(trimmed);
  }

  const domain = segments.slice(0, liveIndex).join('/');
  const user = segments[liveIndex + 1];
  const pass = segments[liveIndex + 2];
  const idWithExt = segments[liveIndex + 3];
  const id = idWithExt.replace(/\.(ts|m3u8)$/i, '');

  if (!domain || !user || !pass || !id || isNaN(Number(id))) {
    return getProxiedUrl(trimmed);
  }

  const finalUrl = `${domain}/live/${user}/${pass}/${id}.m3u8`;
  return getProxiedUrl(finalUrl);
}

export function catchupUrlGenerator(ip, time, duration) {
  let url = ip;
  time = timeConverter(time);
  const trimmed = url.trim();

  if (trimmed.includes('/hlsr/')) {
    return getProxiedUrl(trimmed);
  }

  const segments = trimmed.split('/');
  const liveIndex = segments.findIndex((segment) => segment === 'live');

  if (liveIndex === -1 || segments.length < liveIndex + 4) {
    return getProxiedUrl(trimmed);
  }

  const domain = segments.slice(0, liveIndex).join('/');
  const user = segments[liveIndex + 1];
  const pass = segments[liveIndex + 2];
  const idWithExt = segments[liveIndex + 3];
  const id = idWithExt.replace(/\.(ts|m3u8)$/i, '');

  if (!domain || !user || !pass || !id || isNaN(Number(id))) {
    return getProxiedUrl(trimmed);
  }

  const finalUrl =
    domain +
    '/timeshift/' +
    user +
    '/' +
    pass +
    '/' +
    duration +
    '/' +
    time.split(':').slice(0, -1).join(':').replace(' ', ':') +
    '/' +
    id +
    '.m3u8';
  return getProxiedUrl(finalUrl);
}

const timeConverter = (time) => {
  const a = new Date(time);
  const year = a.getFullYear();
  const month = a.getMonth() + 1;
  const day = a.getDate();
  const hour = a.getHours();
  const min = a.getMinutes();
  const sec = a.getSeconds();

  return (
    year +
    '-' +
    (month < 10 ? '0' + month : month) +
    '-' +
    (day < 10 ? '0' + day : day) +
    ' ' +
    (hour < 10 ? '0' + hour : hour) +
    ':' +
    (min < 10 ? '0' + min : min) +
    ':' +
    (sec < 10 ? '0' + sec : sec)
  );
};

const urlHelpers = { generateUrl, catchupUrlGenerator };
export default urlHelpers;
